// Bottom-center action bar. Drawing tools themselves live in Geoman's top-left
// control; these are the app-level actions.
export default function Toolbar({ measuring, onMeasure, onFit, onExport, dark, onToggleDark, onLeave }) {
  return (
    <div className="toolbar">
      <button
        className={'tool' + (measuring ? ' active' : '')}
        onClick={onMeasure}
        title="Measure a distance (ephemeral)"
      >
        📏 <span>Measure</span>
      </button>
      <button className="tool" onClick={onFit} title="Zoom to fit all features">
        ⊡ <span>Fit</span>
      </button>
      <button className="tool" onClick={onExport} title="Download the map as GeoJSON">
        ⭳ <span>Export</span>
      </button>
      <button className="tool" onClick={onToggleDark} title="Toggle dark interface">
        {dark ? '☀' : '☾'} <span>Theme</span>
      </button>
      <button className="tool leave" onClick={onLeave} title="Leave this room">
        ⤺ <span>Leave</span>
      </button>
    </div>
  )
}
